.timeline {
  width: 100%;
  margin: 20px 10px 10px 10px;
  border-radius: 8px;
}

.timeline-gerencial {
  overflow: auto;
  overflow-x: hidden;
}

.body {
  position: relative;
  min-height: calc(100% - 36px);
}

.rows {
  position: relative;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1RpbWVsaW5lIiwic291cmNlcyI6WyJUaW1lbGluZS5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIudGltZWxpbmUge1xuICB3aWR0aDogMTAwJTtcbiAgbWFyZ2luOiAyMHB4IDEwcHggMTBweCAxMHB4O1xuICBib3JkZXItcmFkaXVzOiA4cHg7XG59XG5cbi50aW1lbGluZS1nZXJlbmNpYWwge1xuICBvdmVyZmxvdzogYXV0bztcbiAgb3ZlcmZsb3cteDogaGlkZGVuO1xufVxuXG4uYm9keSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgbWluLWhlaWdodDogY2FsYygxMDAlIC0gMzZweCk7XG59XG5cbi5yb3dzIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufSJdfQ== */